import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getProps } from '../../drill'

export const getStaticProps = getStaticPropsWrapper(getProps, { campaign: true, path: '/drill' })

export { default } from '../../drill'
